import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnSignOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="m18.12 14.948 2.88-2.88-2.88-2.88m-8.64 2.88h11.441M12 3c-4.973 0-9 3.375-9 9s4.027 9 9 9"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnSignOut;
